import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import {
  CoreLink,
  DiaryForm,
  type DairyEntryValues,
  Main,
} from '../../../components';
import Page from '../../../containers/Page';
import useClasses from '../../../hooks/useClasses';
import useRoutes from '../../../hooks/useRoutes';
import useToast from '../../../hooks/useToast';
import useTypedDispatch from '../../../hooks/useTypedDispatch';
import { nodeAdd } from '../../../store/actions/Entity/Node';
import { viewGet } from '../../../store/actions/Entity/View';

import './style.scss';

const PageDiaryAdd: React.FC = () => {
  const dispatch = useTypedDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const { diary } = useRoutes();
  const { buildClass } = useClasses('PageDiaryAdd');
  const toast = useToast();

  const handleSubmit = (values: DairyEntryValues) => {
    // Temporary.
    // @TODO: Refactor this to make it work more globally.
    const newDiaryEntry = {
      type: [{ target_id: 'diary_entry' }],
      title: [{ value: values.title }],
      field_diary_entry_date: [{ value: values.entryDate }],
      field_diary_body: [{
        value: values.body,
        format: 'poor_text',
      }],
    };

    // Wait for the node to be added.
    dispatch(nodeAdd(newDiaryEntry)).then(() => {
      // Refresh the overview.
      dispatch(viewGet('diary_overview', 'block_1'));
    }).then(() => {
      // If successfully added, navigate to the overview page.
      history.push(diary.overview);

      // Show success toast.
      toast.show(t('pages.diary.add.success_message'), 'success');
    }).catch((error) => {
      if (error) {
        toast.show(t('pages.diary.add.error_message'), 'error');
      }
    });
  };

  return (
    <Page className={buildClass()} goBackHref={diary.overview} title={t('pages.diary.overview.title')}>
      <div className="col-lg-8 py-8 py-lg-12">
        <header className={buildClass('header')}>
          <CoreLink
            to={diary.overview}
            title={t('buttons.back')}
            className="icon-before icon-chevron icon-orientation-left"
          />
        </header>

        <Main className={buildClass('content')}>
          <h1 className={buildClass('title')}>
            {t('pages.diary.add.title')}
          </h1>

          <DiaryForm
            initialValues={{ title: '', body: '', entryDate: null }}
            onSubmit={handleSubmit}
          />
        </Main>
      </div>
    </Page>
  );
};

export default PageDiaryAdd;
